import api from "../service";
import { hotToast } from "utils";

export const getCatalogs = async (table: string, field: string) => {
  let _object = { tabla: table, campo: field };
  let dataB64 = btoa(JSON.stringify(_object));
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `General/GetCatalogs?dataB64=${dataB64}`
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};
